import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import TextLockupV2 from "components/elements/textLockupV2"
import PropTypes from "prop-types"
import React from "react"
import "./section-comparison-table-v2.scss"

const SectionComparisonTableV2 = ({ callsToAction, row, text, title }) => {
  return (
    <section className="section-comparison-table-v2">
      <div className="container-v2">
        <div className="section-comparison-table-v2--content-header">
          {title && (
            <h2 className="section-comparison-table-v2--title">
              <TextLockupV2>{title}</TextLockupV2>
            </h2>
          )}
          {text?.childrenMarkdownRemark?.[0]?.html && (
            <div
              className="section-comparison-table-v2--text"
              dangerouslySetInnerHTML={{
                __html: text?.childrenMarkdownRemark?.[0]?.html,
              }}
            />
          )}
        </div>

        <div className="section-comparison-table-v2--content-table">
          <table className="section-comparison-table-v2--table">
            <thead>
              <tr>
                <th>Focus Areas</th>
                <th className="logo-cell">
                  <span aria-label="Cortica" className="logo">
                    <svg
                      fill="none"
                      height="34"
                      viewBox="0 0 120 34"
                      width="120"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#a)" fill="#11389a">
                        <path d="M46.45 26.305c4.571 0 7.666-2.985 8.094-6.803h-3.146c-.35 2.312-2.334 4.087-4.949 4.087-3.55 0-6.131-2.582-6.131-6.91s2.555-6.912 6.132-6.912c2.608 0 4.491 1.613 4.866 3.898h3.147c-.377-3.845-3.5-6.615-8.014-6.615-5.351 0-9.304 3.603-9.304 9.628 0 6.05 4.011 9.627 9.304 9.627M62.438 26.373c4.06 0 6.991-2.905 6.991-7.02 0-4.086-2.931-6.965-6.992-6.965-4.06 0-7 2.879-7 6.965s2.939 7.02 7 7.02m-4-7.02c0-2.635 1.666-4.436 4-4.436 2.366 0 4 1.833 4 4.436 0 2.667-1.64 4.492-4 4.492-2.34 0-4.007-1.828-4.007-4.492zM70.578 26.167h2.93v-5.254c0-3.898 1.722-5.781 3.819-5.781a4.6 4.6 0 0 1 1.801.35v-2.815a3.9 3.9 0 0 0-1.531-.27c-1.695 0-3.309.915-4.089 2.286v-2.08h-2.93zM86.568 26.374a4.9 4.9 0 0 0 1.881-.35v-2.5c-.482.17-.988.26-1.5.27-1.156 0-1.91-.727-1.91-2.179v-6.59h3.304v-2.421h-3.309v-3.36h-2.958v3.36h-2.205v2.421h2.205v6.833c0 2.929 1.917 4.515 4.492 4.515M89.764 26.167h2.931V12.603h-2.931zm-.432-17.624c0 1.049.807 1.834 1.883 1.834s1.882-.78 1.882-1.834c0-1.053-.807-1.833-1.882-1.833s-1.883.79-1.883 1.833M100.958 26.373c3.5 0 5.97-2.26 6.374-5.083h-2.959c-.268 1.533-1.586 2.555-3.415 2.555-2.178 0-3.846-1.855-3.846-4.492 0-2.608 1.666-4.436 3.846-4.436 1.722 0 3.012.968 3.307 2.475h2.958c-.403-3.014-2.716-5-6.265-5-3.98 0-6.833 2.931-6.833 6.965.002 4.058 2.88 7.016 6.833 7.016M112.976 26.373c1.833 0 3.5-1 4.06-2.178v1.972h2.958v-8.534c0-3.333-2.42-5.245-5.808-5.245-3.334 0-5.487 2.152-5.862 4.815h2.957c.215-1.586 1.291-2.448 2.905-2.448 1.721 0 2.85.942 2.85 2.528v.35l-2.744.269c-4.195.456-6.05 1.855-6.05 4.545 0 2.34 1.855 3.926 4.734 3.926m-1.802-4.061c0-1.344.968-1.909 3.253-2.179l2.609-.321v.376c0 2.15-1.425 3.845-3.577 3.845-1.398 0-2.285-.645-2.285-1.721M28.878 7.065a8.04 8.04 0 0 1-8.195.089 8 8 0 0 1-3.295-3.627 12.1 12.1 0 0 1-1.447 3.222 10.9 10.9 0 0 0 3.292 2.918 10.94 10.94 0 0 0 11.095-.088zM26.173 16.657a8 8 0 0 1 1.5-4.667c-1.148.29-2.332.41-3.514.358a10.95 10.95 0 0 0 4.768 13.889l1.45-2.514a8.04 8.04 0 0 1-4.204-7.066M20.686 26.167a8 8 0 0 1 4.786-1.04 12.2 12.2 0 0 1-2.065-2.864 10.957 10.957 0 0 0-9.643 11.107h2.9a8.04 8.04 0 0 1 4.022-7.203M11.163 23.649a10.94 10.94 0 0 0-11.167.128l1.452 2.513a8.04 8.04 0 0 1 11.556 3.5 12.3 12.3 0 0 1 1.447-3.221 10.9 10.9 0 0 0-3.288-2.92M1.46 7.065.007 9.578a8.04 8.04 0 0 1 4.22 7.079 8 8 0 0 1-1.5 4.666c1.147-.29 2.33-.41 3.513-.358.583-1.361.882-2.827.88-4.308A10.95 10.95 0 0 0 1.46 7.065M9.71 7.153a8 8 0 0 1-4.788 1.04 12.2 12.2 0 0 1 2.073 2.864A10.941 10.941 0 0 0 16.632 0H13.73a8.04 8.04 0 0 1-4.02 7.153M15.187 19.334a2.651 2.651 0 1 0 0-5.303 2.651 2.651 0 0 0 0 5.303" />
                      </g>
                      <defs>
                        <clipPath id="a">
                          <path d="M0 0h120v33.37H0z" fill="#fff" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </th>
                <th>Standard ABA Treatment Centers</th>
              </tr>
            </thead>
            <tbody>
              {row?.map(row => (
                <tr key={row.id}>
                  <td>{row?.title}</td>
                  <td className="center-cell">
                    <span
                      aria-label={`Checkmark: ${row?.cortica}`}
                      className="checkmark"
                      role="img"
                    >
                      {row?.cortica ? (
                        <svg
                          aria-hidden="true"
                          fill="none"
                          focusable="false"
                          height="36"
                          viewBox="0 0 36 36"
                          width="36"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect fill="#11389a" height="36" rx="18" width="36" />
                          <g clipPath="url(#a)">
                            <path
                              d="m15 22.17-3.47-3.47a.996.996 0 1 0-1.41 1.41l4.18 4.18c.39.39 1.02.39 1.41 0l10.58-10.58a.996.996 0 1 0-1.41-1.41z"
                              fill="#f9f8f2"
                            />
                          </g>
                          <defs>
                            <clipPath id="a">
                              <path d="M6 6h24v24H6z" fill="#fff" />
                            </clipPath>
                          </defs>
                        </svg>
                      ) : (
                        <svg
                          fill="none"
                          height="24"
                          viewBox="0 0 24 24"
                          width="24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#a)" opacity=".5">
                            <path
                              d="M18.299 5.71a.996.996 0 0 0-1.41 0l-4.89 4.88-4.89-4.89a.996.996 0 1 0-1.41 1.41l4.89 4.89-4.89 4.89a.996.996 0 1 0 1.41 1.41l4.89-4.89 4.89 4.89a.996.996 0 1 0 1.41-1.41L13.409 12l4.89-4.89c.38-.38.38-1.02 0-1.4"
                              fill="#122f4e"
                            />
                          </g>
                          <defs>
                            <clipPath id="a">
                              <path d="M0 0h24v24H0z" fill="#fff" />
                            </clipPath>
                          </defs>
                        </svg>
                      )}
                    </span>
                  </td>
                  <td className="center-cell">
                    <span
                      aria-label={`Checkmark: ${row?.standard}`}
                      className="checkmark"
                      role="img"
                    >
                      {row?.standard ? (
                        <svg
                          aria-hidden="true"
                          fill="none"
                          focusable="false"
                          height="36"
                          viewBox="0 0 36 36"
                          width="36"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect fill="#11389a" height="36" rx="18" width="36" />
                          <g clipPath="url(#a)">
                            <path
                              d="m15 22.17-3.47-3.47a.996.996 0 1 0-1.41 1.41l4.18 4.18c.39.39 1.02.39 1.41 0l10.58-10.58a.996.996 0 1 0-1.41-1.41z"
                              fill="#f9f8f2"
                            />
                          </g>
                          <defs>
                            <clipPath id="a">
                              <path d="M6 6h24v24H6z" fill="#fff" />
                            </clipPath>
                          </defs>
                        </svg>
                      ) : (
                        <svg
                          fill="none"
                          height="24"
                          viewBox="0 0 24 24"
                          width="24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#a)" opacity=".5">
                            <path
                              d="M18.299 5.71a.996.996 0 0 0-1.41 0l-4.89 4.88-4.89-4.89a.996.996 0 1 0-1.41 1.41l4.89 4.89-4.89 4.89a.996.996 0 1 0 1.41 1.41l4.89-4.89 4.89 4.89a.996.996 0 1 0 1.41-1.41L13.409 12l4.89-4.89c.38-.38.38-1.02 0-1.4"
                              fill="#122f4e"
                            />
                          </g>
                          <defs>
                            <clipPath id="a">
                              <path d="M0 0h24v24H0z" fill="#fff" />
                            </clipPath>
                          </defs>
                        </svg>
                      )}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {callsToAction?.length > 0 && (
          <div className="section-comparison-table-v2--content-ctas">
            {callsToAction?.map(ctaButton => (
              <p
                className="section-comparison-table-v2--content-cta"
                key={ctaButton?.id}
              >
                <ButtonV2
                  accessibilityLabel={ctaButton?.accessibilityLabel}
                  className={getButtonClasses(
                    ctaButton?.buttonStyle,
                    ctaButton?.buttonSize
                  )}
                  href={ctaButton?.path}
                  key={ctaButton?.id}
                  showArrow={ctaButton?.showArrow === "Yes" ? true : false}
                  text={ctaButton?.text}
                />
              </p>
            ))}
          </div>
        )}
      </div>
    </section>
  )
}

SectionComparisonTableV2.propTypes = {
  callsToAction: PropTypes.arrayOf(PropTypes.object).isRequired,
  row: PropTypes.arrayOf(PropTypes.object).isRequired,
  text: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
}

export default SectionComparisonTableV2
